import React from 'react';
import { IconMoon, IconSun } from './Icons';
import './ThemeToggle.css';

function ThemeToggle({ theme = 'dark', onToggle, collapsed = false, compact = false }) {
  const isLight = theme === 'light';
  return (
    <button
      type="button"
      className={`theme-toggle${collapsed ? ' is-collapsed' : ''}${compact ? ' is-compact' : ''}`}
      onClick={onToggle}
      aria-pressed={isLight}
      aria-label={isLight ? 'Switch to dark mode' : 'Switch to light mode'}
      title={isLight ? 'Switch to dark mode' : 'Switch to light mode'}
    >
      <span className="theme-toggle-icon" aria-hidden="true">
        {isLight ? <IconMoon size={18} /> : <IconSun size={18} />}
      </span>
      {!compact && (
        <span className="theme-toggle-label">{isLight ? 'Dark mode' : 'Light mode'}</span>
      )}
    </button>
  );
}

export default ThemeToggle;
